import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`fl `),
  style: {"height":"68px"}
}
const _hoisted_2 = { class: "fl fs16 fw600 mt8 mr20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = { class: "fl ml5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fs16 fw600 dgrey" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fl mr5" }, "共通の設定"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "fl greyBg rad5 fs11 pointer hoverGreyBg",
    style: {"padding":"3px 10px"}
  }, "変更"),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_6 = { class: "mt1 fs11 fw600 grey arial" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  class: "fl fw600 mr10 dgrey fs14 mt4",
  style: {"width":"150px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  class: "fr fs13 fw600 posAb",
  style: {"right":"5px","bottom":"5px"}
}
const _hoisted_12 = {
  key: 0,
  class: "mb10"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHelp = _resolveComponent("IconHelp")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_IconGear = _resolveComponent("IconGear")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.cm.astag)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", {
          class: _normalizeClass(`fl kakugo pointer ${_ctx.isSP ? 'fs13' : 'ls1 fs13'} mt15`),
          style: {"line-height":"68px"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHelpCenter && _ctx.goHelpCenter(...args)))
        }, [
          _createVNode(_component_IconHelp, {
            width: 34,
            class: "fl mr10",
            tooltipText: `使い方ヘルプページ`,
            color: `white`,
            onClick: _ctx.goHelpCenter
          }, null, 8, ["onClick"])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(`dgrey fl posRe fw600 mr10 with_white_bg pad7 ${_ctx.isSP ? `ml2` : `mt8 rad16`}`),
          style: {}
        }, [
          _createVNode(_component_CalendarIcon, {
            astag: _ctx.cm.astag,
            width: 40,
            iconWidth: 40,
            totalHeight: 40,
            canDelete: false,
            hideName: true,
            hideBorder: true,
            classes: `fl ml5`
          }, null, 8, ["astag"]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.truncate(_ctx.cm.astag.name || ``, 15)), 1)
          ])), [
            [
              _directive_tooltip,
              _ctx.cm.astag.name && _ctx.cm.astag.name.length > 15 ? _ctx.cm.astag.name : null,
              void 0,
              { bottom: true }
            ]
          ]),
          _createElementVNode("div", {
            class: "fl greyBg rad5 mt6 fs11 pointer hoverGreyBg mr5",
            style: {"padding":"5px 10px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickChangeName && _ctx.clickChangeName(...args)))
          }, " 名前変更 "),
          _hoisted_3
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(`fl mr10 pointer with_white_bg pad6 ${_ctx.isSP ? `ml2` : `mt8 rad16`}`)
        }, [
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editAstag && _ctx.editAstag(...args)))
          }, [
            _createVNode(_component_IconGear, {
              width: 24,
              class: "fl pointer ml10",
              tooltipText: `調整カレンダー全体で適用する表示ルールを設定します`
            }),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass(`fl padw3 rad5 mr7 ${_ctx.cm.astag.ignore_allday ? `dblueBg` : `borderDgrey`}`)
                }, "終日無視", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(`fl padw3 rad5 mr7 ${_ctx.cm.astag.can_use_available_event_keyword ? `dblueBg` : `borderDgrey`}`)
                }, " 可能日時反転 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(`fl padw3 rad5 mr7 ${_ctx.cm.astag.can_use_ignore_event_keyword ? `dblueBg` : `borderDgrey`}`)
                }, " イベント無視 ", 2)
              ])
            ]),
            _hoisted_7
          ]),
          _hoisted_8
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(`fl mr10 with_white_bg pad14 ${_ctx.isSP ? `ml2` : `mt8 rad16`}`)
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode(" 手動選択モード "),
            _createVNode(_component_IconHelp, {
              width: 18,
              class: "ml5",
              tooltipText: `自動で提案候補を抽出せず、日程を選択した箇所だけをお相手に表示します。`,
              style: {"margin-top":"-3px","margin-right":"5px"}
            })
          ]),
          _createVNode(_component_Switcher, {
            value: "type[ignore]",
            name: "自動抽出設定",
            checked: _ctx.cm.astag.is_only_use_optional_schedules,
            display: "true",
            class: "checkUsingCal fl",
            onSelect: _ctx.clickChangeAutoMode
          }, null, 8, ["checked", "onSelect"]),
          _hoisted_10
        ], 2),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.cm.astag.is_shared && _ctx.cm.astag.owner)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_UserIcon, {
                  member: _ctx.cm.astag.owner,
                  width: 22,
                  canEdit: false,
                  updateSelf: false,
                  showTooltip: false,
                  class: "fr mr3"
                }, null, 8, ["member"]),
                _createElementVNode("img", {
                  class: "fr mr2 mt2",
                  width: "18",
                  height: "18",
                  src: _ctx.$getAssetImageUrl(`/assets/icons/refresh.png`)
                }, null, 8, _hoisted_13),
                _hoisted_14
              ])), [
                [
                  _directive_tooltip,
                  `${_ctx.cm.astag.owner.name}さんから共有を受けています`,
                  void 0,
                  { click: true }
                ]
              ])
            : _createCommentVNode("", true),
          _hoisted_15,
          (_ctx.showTimezone)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, "「" + _toDisplayString(_ctx.pdm.jpTimezoneValue) + "」の時間で表示しています", 1))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}